import { Injectable, EventEmitter } from '@angular/core';
// import 'rxjs/Rx';

import { Mast, ReportRequest } from '../dbcontroller/mast';
// import { SailsService } from "angular2-sails";
import { AMControllerService } from "./dbcontroller.service";
// import { inoutinfo } from 'src/app/inout/inoutformclass';
// import { stdinfo } from 'src/app/school/student/registration/regstrationclass';
// import { feeinfo } from 'src/app/school/fee/feereceipt/feereceiptclass';
// import { gateentryinfo } from 'src/app/school/gateentry/gateentryform/gateentryclass';
import { dealerOrderinfo } from 'src/app/dealerorder/dealerorderclass';
// import { soinfo } from 'src/app/orders/soformclass';

@Injectable()
export class ServServiceService {

  SuccessEvent = new EventEmitter<Mast>();
  FaildedEvent = new EventEmitter<Mast>();

  DuplicateEvent = new EventEmitter<Mast>();
  DeletedEvent = new EventEmitter<number>();

  SingleValueMasterEvent = new EventEmitter<Mast>();
  // FaildedSingleValueMasterEvent = new EventEmitter<Mast>();
  // DuplicateSingleValueMasterEvent = new EventEmitter<Mast>();
  // DeletedSingleValueMasterEvent = new EventEmitter<number>();
  // UpdatedSingleValueMasterEvent = new EventEmitter<number>();

  SuccessTimetableEvent = new EventEmitter<Mast>();
  FaildedTimetableEvent = new EventEmitter<Mast>();
  DuplicateTimetableEvent = new EventEmitter<Mast>();
  DeletedTimetableEvent = new EventEmitter<number>();
  UpdatedTimetableEvent = new EventEmitter<number>();

  SuccessUserListEvent = new EventEmitter<Mast>();
  FaildedUserListEvent = new EventEmitter<Mast>();
  DuplicateUserListEvent = new EventEmitter<Mast>();
  DeletedUserListEvent = new EventEmitter<number>();
  UpdateUserListEvent = new EventEmitter<Mast>();

  // SuccessStdRegEvent = new EventEmitter<stdinfo>(); // Ac type = 1
  // UpdatedStdRegMasterEvent = new EventEmitter<number>(); // Ac type = 2
  // DeletedStdRegMasterEvent = new EventEmitter<number>(); // Ac type = 3
  // ReportResponseStdRegEvent = new EventEmitter<ReportRequest>(); // Ac type = 3
  // FaildedStdRegMasterEvent = new EventEmitter<stdinfo>(); // Ac type = 101

  // SuccessFeeEntryEvent = new EventEmitter<feeinfo>(); // Ac type = 1
  // UpdatedFeeEntryEvent = new EventEmitter<number>(); // Ac type = 2
  // DeletedFeeEntryEvent = new EventEmitter<number>(); // Ac type = 3
  // PendingMonthFeeEntryEvent = new EventEmitter<ReportRequest>(); // Ac type = 10
  // ReportResponseFeeEntryEvent = new EventEmitter<ReportRequest>(); // Ac type = 11
  // FeeCardResponseFeeEntryEvent = new EventEmitter<ReportRequest>(); // Ac type = 12
  // FeeUpdateDataReqResponseEvent = new EventEmitter<ReportRequest>(); // Ac type = 13
  // SuccessFeeEntryBroadcastEvent = new EventEmitter<feeinfo>(); // Ac type = 11
  // FaildedFeeEntryEvent = new EventEmitter<feeinfo>(); // Ac type = 101

  // SuccessInoutEntryEvent = new EventEmitter<inoutinfo>(); // Ac type = 1
  // UpdatedInoutEntryEvent = new EventEmitter<number>(); // Ac type = 2
  // DeletedInoutEntryEvent = new EventEmitter<number>(); // Ac type = 3
  // ReportResponseInoutEntryEvent = new EventEmitter<ReportRequest>(); // Ac type = 3
  // ReportResponseInoutUpdateEntryEvent = new EventEmitter<ReportRequest>(); // Ac type = 3
  // ReportResponseInoutSlipEvent = new EventEmitter<ReportRequest>(); // Ac type = 3
  // FaildedInoutEntryEvent = new EventEmitter<inoutinfo>(); // Ac type = 103

  // SuccessSOEntryEvent = new EventEmitter<soinfo>(); // Ac type = 1
  // UpdatedSOEntryEvent = new EventEmitter<number>(); // Ac type = 2
  // DeletedSOEntryEvent = new EventEmitter<number>(); // Ac type = 3
  // ReportResponseSOEntryEvent = new EventEmitter<ReportRequest>(); // Ac type = 3
  // ReportResponseSOUpdateEntryEvent = new EventEmitter<ReportRequest>(); // Ac type = 3
  // ReportResponseSOSlipEvent = new EventEmitter<ReportRequest>(); // Ac type = 3
  // FaildedSOEntryEvent = new EventEmitter<soinfo>(); // Ac type = 103

  // SuccessTTAdjEntryEvent = new EventEmitter<soinfo>(); // Ac type = 1
  // ReportResponseTTAdjEntryEvent = new EventEmitter<number>(); // Ac type = 2

  SuccessDealerOrderEntryEvent = new EventEmitter<any>(); // Ac type = 1
  UpdatedDealerOrderEntryEvent = new EventEmitter<number>(); // Ac type = 2
  DeletedDealerOrderEntryEvent = new EventEmitter<number>(); // Ac type = 3
  ReportResponseDealerOrderEntryEvent = new EventEmitter<ReportRequest>(); // Ac type = 3
  ReportResponseDealerOrderStatusEvent = new EventEmitter<ReportRequest>(); // Ac type = 3
  ReportResponseDealerOrderUpdateEntryEvent = new EventEmitter<ReportRequest>(); // Ac type = 3
  FaildedDealerOrderEntryEvent = new EventEmitter<dealerOrderinfo>(); // Ac type = 103

  // SuccessGateEntryEvent = new EventEmitter<gateentryinfo>(); // Ac type = 1
  // SuccessGateEntryBroadcastEvent = new EventEmitter<gateentryinfo>(); // Ac type = 1
  // FailedGateEntryEvent = new EventEmitter<gateentryinfo>(); // Ac type = 101
  // DeletedGateEntryEvent = new EventEmitter<number>(); // Ac type = 3
  ReportResponseGateEntryEvent = new EventEmitter<ReportRequest>(); // Ac type = 3

  SuccessCashMasterEvent = new EventEmitter<Mast>();
  FaildedCashMasterEvent = new EventEmitter<Mast>();
  CashLedgerRepResEvent = new EventEmitter<Mast>();
  CashLedgerDetailRepResEvent = new EventEmitter<Mast>();

  LedgerRepResEvent = new EventEmitter<any>();
  ResultRepResEvent = new EventEmitter<any>();

  UsersConnectionEvent = new EventEmitter<Mast>();
  ReportResponseinoutEvent: any;

  constructor(private controllerService: AMControllerService) {
    controllerService.socket.on('DistrWithInComp', (resData) => { this.handleBroadCastedResponse(resData); });
    controllerService.socket.on('reqres', (resData) => { this.handleReqResponse(resData); });
    controllerService.socket.on('autologin', (resData) => { this.AutologinRequest(resData); });
    controllerService.socket.on('disconnect', () => { this.controllerService.showDialogFailedInfo('connection Lost'); });
    controllerService.socket.on('reconnecting', () => { this.controllerService.showDialogFailedInfo('Reconnecting.....'); });
    controllerService.socket.on('reconnect', () => { this.controllerService.showDialogSuccessInfo('Reconnected'); });
    controllerService.socket.on('connect', () => {

      this.controllerService.userinfo.actionType = -1;
      if (this.controllerService.isotplogin) {
        this.controllerService.userinfo.frmid = 112;
      } else {
        this.controllerService.userinfo.frmid = 111;
      }
      this.controllerService.sendRequest(this.controllerService.userinfo);
      // this.AutologinRequest(this.controllerService.userinfo);
      this.controllerService.showDialogSuccessInfo('connected');
    });
  }

  AutologinRequest(data: any) { // It works when user Re - connect to server
    if (data.length > 0) {
      this.controllerService.activeUserList = data;
    }
  }

  handleReqResponse(data: any) {
    // this.controllerService.uiloader.stopAll();
    var responseinfo: any;
    responseinfo = data;

     if (responseinfo.actionType == 101) {
      this.controllerService.showDialogFailedInfo(this.controllerService.ErrorCodeWithMessages.filter(x => x.id == data.actionType)[0].str1 + responseinfo.frmid + "(" + responseinfo.actionType + ")");
    } else if (responseinfo.actionType == 110) {
      this.controllerService.showDialogFailedInfo(this.controllerService.ErrorCodeWithMessages.filter(x => x.id == data.actionType)[0].str1);
    } else if (responseinfo.actionType == 500) {
      this.controllerService.showDialogFailedInfo(this.controllerService.ErrorCodeWithMessages.filter(x => x.id == data.actionType)[0].str1);
    } else {
      switch (responseinfo.frmid) {
        case 1:
          if (responseinfo.actionType == 1) {
            this.controllerService.userList.push(responseinfo);
            this.SuccessUserListEvent.emit(responseinfo);
          } else if (responseinfo.actionType == 2) {
            this.controllerService.userList.push(responseinfo);
            this.UpdateUserListEvent.emit();
          } else if (responseinfo.actionType == 3) {
            this.controllerService.findAndRemove(this.controllerService.activeUserList, 'id', responseinfo.id);
            this.DeletedUserListEvent.emit();
          } else if (responseinfo.actionType == 102) {
            this.DuplicateUserListEvent.emit();
          } else {
            console.log('hey hey something is wrong... in response');
          }
          break;
        case 10:
        case 11:
        case 12:
        case 13:
        case 14:
        case 15:
        case 16:
        case 17:
        case 18:
        case 19:
        case 20:
        case 21:
        case 22:
        case 23:
        case 24:
        case 26:
        case 27:
        case 28:
        case 29:
        case 30:
        case 31:
        case 44:
        case 46:
          if (responseinfo.actionType == 1) {
            if (responseinfo.frmid == 21) {
              this.controllerService.items.push(responseinfo);
            } else if (responseinfo.frmid == 22) {
              this.controllerService.accounts.push(responseinfo);
            } else {
              this.controllerService.getMastersArrayByFormID(responseinfo.frmid).push(responseinfo);
              if (responseinfo.frmid == 14) {
                this.controllerService.getMastersArrayByFormID(responseinfo.frmid).push(responseinfo.arr);
              }
            }
            this.SingleValueMasterEvent.emit(responseinfo);
          } else if (responseinfo.actionType == 2) {
            if (responseinfo.frmid == 21) {
              this.controllerService.findAndReplace(this.controllerService.items, 'id', responseinfo.id,responseinfo);
            } else if (responseinfo.frmid == 22) {
              this.controllerService.findAndReplace(this.controllerService.accounts, 'id', responseinfo.id,responseinfo);
            } else {
              if (responseinfo.frmid == 14) {
                if (responseinfo.arr.length > 0) {
                  for (let key of responseinfo.arr) {
                    if (key.del != undefined && key.del == true) {
                      this.controllerService.findAndRemove((key.frmid == 1401 ? this.controllerService.classeWiseFees:this.controllerService.classeWiseTeachers), 'id', key.id);
                    } else {
                      if ((key.frmid == 1401 ? this.controllerService.classeWiseFees:this.controllerService.classeWiseTeachers).find(x => x.id == key.id) == null) {
                        (key.frmid == 1401 ? this.controllerService.classeWiseFees:this.controllerService.classeWiseTeachers).push(key);
                      } else {
                        this.controllerService.findAndReplace((key.frmid == 1401 ? this.controllerService.classeWiseFees:this.controllerService.classeWiseTeachers), 'id', key.id,key);
                      }
                    }
                  }
                }
              }
              this.controllerService.findAndReplace(this.controllerService.getMastersArrayByFormID(responseinfo.frmid), 'id', responseinfo.id,responseinfo);
            }
            this.SingleValueMasterEvent.emit(responseinfo);
          } else if (responseinfo.actionType == 3) {
            if (responseinfo.frmid == 21) {
              this.controllerService.findAndRemove(this.controllerService.items, 'id', responseinfo.id);
            } else if (responseinfo.frmid == 22) {
              this.controllerService.findAndRemove(this.controllerService.accounts, 'id', responseinfo.id);
            } else {
              this.controllerService.findAndRemove(this.controllerService.getMastersArrayByFormID(responseinfo.frmid), 'id', responseinfo.id);
            }
            this.SingleValueMasterEvent.emit(responseinfo);
          } else if (responseinfo.actionType == 102) {
            // this.DuplicateSingleValueMasterEvent.emit();
            this.SingleValueMasterEvent.emit(responseinfo);
            this.controllerService.showDialogFailedInfo('Duplicate Entry Failed');
          } else if (responseinfo.actionType == 103) {
            this.controllerService.showDialogFailedInfo('Master already in Use');
          } else {
            console.log('hey hey something is wrong... in response');
            this.controllerService.showDialogFailedInfo('Acc Creation Failed');
          }
          break;
        case 101:
          // if (responseinfo.actionType == 1) {
          //   responseinfo.class = this.controllerService.getclassname(responseinfo.stdclass);
          //   responseinfo.section = this.controllerService.getsectionname(responseinfo.stdsec);
          //   responseinfo.category = this.controllerService.getcategoryname(responseinfo.stdcat);
          //   responseinfo.religion = this.controllerService.getreligionname(responseinfo.stdrelgn);
          //   responseinfo.house = this.controllerService.gethousename(responseinfo.stdhouse);
          //   responseinfo.gender = responseinfo.stdgender == 1 ? 'Male' : 'Female';

          //   this.controllerService.studentslist.push(responseinfo);
          //   if (responseinfo.std_docs != null && responseinfo.std_docs.length > 0) {
          //     this.controllerService.studentdocs.push(responseinfo.std);
          //   }
          //   this.SuccessStdRegEvent.emit();
          // } else if (responseinfo.actionType == 2) {

          //   responseinfo.class = this.controllerService.getclassname(responseinfo.stdclass);
          //   responseinfo.section = this.controllerService.getsectionname(responseinfo.stdsec);
          //   responseinfo.category = this.controllerService.getcategoryname(responseinfo.stdcat);
          //   responseinfo.religion = this.controllerService.getreligionname(responseinfo.stdrelgn);
          //   responseinfo.house = this.controllerService.gethousename(responseinfo.stdhouse);
          //   responseinfo.gender = responseinfo.stdgender == 1 ? 'Male' : 'Female';

          //   this.controllerService.findAndReplace(this.controllerService.studentslist, 'id', responseinfo.id,responseinfo);
          //   if (responseinfo.std_docs != null && responseinfo.std_docs.length > 0) {
          //     for (let entry of responseinfo.std_docs) {
          //       if (entry.del != null && entry.del == true) {
          //         this.controllerService.findAndRemove(this.controllerService.studentdocs, 'recid', entry.recid);
          //       } else {
          //         entry.id = entry.recid;
          //         if (this.controllerService.studentdocs.find(x => x.recid == entry.recid) != null) {
          //           this.controllerService.findAndReplace(this.controllerService.studentdocs, 'recid', entry.id,entry);
          //         } else {
          //           this.controllerService.studentdocs.push(entry);
          //         }

          //       }
          //     }
          //     // this.controllerService.studentdocs.push(responseinfo.std)
          //   }
          //   this.UpdatedStdRegMasterEvent.emit();
          // } else if (responseinfo.actionType == 3) {
          //   this.DeletedStdRegMasterEvent.emit();
          // } else if (responseinfo.actionType == 10) {

          //   this.controllerService.studentslist = [];
          //   this.controllerService.studentdocs = [];
          //   this.controllerService.prepareLocalArray(responseinfo.responseData, this.controllerService);

          //   this.ReportResponseStdRegEvent.emit(responseinfo);
          // } else if (responseinfo.actionType == 11) {
          //   this.ReportResponseStdRegEvent.emit(responseinfo);
          // } else if (responseinfo.actionType == 12) {
          //   this.ReportResponseStdRegEvent.emit(responseinfo);
          // } if (responseinfo.actionType == 101) {
          //   this.FaildedStdRegMasterEvent.emit();
          // }
          break;
        case 102:
          // if (responseinfo.actionType == 1) {
          //   var currstd = this.controllerService.studentslist.find(x => x.id == responseinfo.stdid);
          //   responseinfo.stdname = currstd.stdname;
          //   responseinfo.stdadmno = currstd.stdadmno;
          //   responseinfo.stdfathnm = currstd.stdfathrnm;
          //   responseinfo.stdclass = this.controllerService.getclassname(currstd.stdclass);
          //   responseinfo.stdsection = this.controllerService.getsectionname(currstd.stdsec);
          //   responseinfo.paymodename = this.controllerService.getpaymentmodename(responseinfo.paymode);
          //   responseinfo.username = this.controllerService.getUserName(responseinfo.userid);
          //   this.controllerService.feedaybooklist.push(responseinfo);
          //   this.SuccessFeeEntryEvent.emit(responseinfo);

          // } else if (responseinfo.actionType == 2) {
          //   var currstd = this.controllerService.studentslist.find(x => x.id == responseinfo.stdid);
          //   responseinfo.stdname = currstd.stdname;
          //   responseinfo.stdadmno = currstd.stdadmno;
          //   responseinfo.stdfathnm = currstd.stdfathrnm;
          //   responseinfo.stdclass = this.controllerService.getclassname(currstd.stdclass);
          //   responseinfo.stdsection = this.controllerService.getsectionname(currstd.stdsec);
          //   responseinfo.paymodename = this.controllerService.getpaymentmodename(responseinfo.paymode);
          //   responseinfo.username = this.controllerService.getUserName(responseinfo.userid);
          //   this.controllerService.findAndReplace(this.controllerService.feedaybooklist, 'id', responseinfo.id,responseinfo);
          //   this.UpdatedFeeEntryEvent.emit();
          // } else if (responseinfo.actionType == 3) {
          //   this.DeletedFeeEntryEvent.emit();
          // } else if (responseinfo.actionType == 10) {
          //   this.PendingMonthFeeEntryEvent.emit(responseinfo);
          // } else if (responseinfo.actionType == 11 || responseinfo.actionType == 15 || responseinfo.actionType == 16) {
          //   this.ReportResponseFeeEntryEvent.emit(responseinfo);
          // } else if (responseinfo.actionType == 12 || responseinfo.actionType == 12.1) {
          //   this.FeeCardResponseFeeEntryEvent.emit(responseinfo);
          // } else if (responseinfo.actionType == 13 || responseinfo.actionType == 14) {
          //   this.FeeUpdateDataReqResponseEvent.emit(responseinfo);
          // } else if (responseinfo.actionType == 101) {
          //   this.FaildedFeeEntryEvent.emit();
          // }
          break;
        case 103:
        case 105:
        case 106:
        case 107:
          // if (responseinfo.actionType == 1) {
          //   this.SuccessInoutEntryEvent.emit(responseinfo);
          // } else if (responseinfo.actionType == 2) {
          //   this.UpdatedInoutEntryEvent.emit(responseinfo);
          // } else if (responseinfo.actionType == 3) {
          //   this.DeletedInoutEntryEvent.emit();
          // } else if (responseinfo.actionType == 10 || responseinfo.actionType == 12 || responseinfo.actionType == 13 || responseinfo.actionType == 14 || responseinfo.actionType == 16) {
          //   this.ReportResponseInoutEntryEvent.emit(responseinfo);
          // } else if (responseinfo.actionType == 11) {
          //   this.ReportResponseInoutUpdateEntryEvent.emit(responseinfo);
          // } else if (responseinfo.actionType == 15) {
          //   this.ReportResponseInoutSlipEvent.emit(responseinfo);
          // } else if (responseinfo.actionType == 101) {
          //   this.FaildedFeeEntryEvent.emit();
          // }
          break;
        case 113:
          if (responseinfo.actionType == 1) {
            this.SuccessTimetableEvent.emit(responseinfo);
            this.controllerService.getMastersArrayByFormID(responseinfo.frmid).push(responseinfo);
          } else if (responseinfo.actionType == 2) {
            this.UpdatedTimetableEvent.emit(responseinfo);
            this.controllerService.findAndReplace(this.controllerService.timetables, 'id', responseinfo.id,responseinfo);
          } else if (responseinfo.actionType == 3) {
            this.DeletedTimetableEvent.emit(responseinfo);
            this.controllerService.findAndRemove(this.controllerService.timetables, 'id', responseinfo.id);
          } else if (responseinfo.actionType == 101) {
            this.FaildedTimetableEvent.emit(responseinfo);
          }
        case 115:
          // if (responseinfo.actionType == 1) {
          //   this.SuccessSOEntryEvent.emit(responseinfo);
          // } else if (responseinfo.actionType == 2) {
          //   this.UpdatedSOEntryEvent.emit(responseinfo);
          // } else if (responseinfo.actionType == 3) {
          //   this.DeletedSOEntryEvent.emit();
          // } else if (responseinfo.actionType == 10 || responseinfo.actionType == 12 || responseinfo.actionType == 13 || responseinfo.actionType == 14) {
          //   this.ReportResponseSOEntryEvent.emit(responseinfo);
          // } else if (responseinfo.actionType == 11) {
          //   this.ReportResponseSOUpdateEntryEvent.emit(responseinfo);
          // } else if (responseinfo.actionType == 15) {
          //   this.ReportResponseSOSlipEvent.emit(responseinfo);
          // }
          break;
        case 116:
          // if (responseinfo.actionType == 1) {
          //   this.SuccessTTAdjEntryEvent.emit(responseinfo);
          // } else if (responseinfo.actionType == 4) {
          //   this.ReportResponseTTAdjEntryEvent.emit(responseinfo);
          // } 
          break;
        case 104:
          // if (responseinfo.actionType == 1) {
          //   this.controllerService.gateentrylist.push(new gateentryinfo(responseinfo.srno, responseinfo.name, responseinfo.address, responseinfo.tomeet,
          //     responseinfo.purpose, responseinfo.mobile, responseinfo.type, responseinfo.stdid, responseinfo.remarks, responseinfo.frmid, responseinfo.compid, responseinfo.sessid,
          //     0, responseinfo.userid, responseinfo.ctime));
          //   this.SuccessGateEntryEvent.emit(responseinfo);
          //   // } else if (responseinfo.actionType == 2) {
          //   //   this.UpdatedGateEntryEvent.emit();
          // } else if (responseinfo.actionType == 10) {
          //   this.ReportResponseGateEntryEvent.emit(responseinfo);
          // } else if (responseinfo.actionType == 101) {
          //   this.FailedGateEntryEvent.emit(responseinfo);
          // }
          break;
        case 108:
          if (responseinfo.actionType == 1) {
            // for (var trrow of responseinfo.trdetail) {
            //   this.controllerService.currTransections.push(trrow);
            // }
            this.SuccessCashMasterEvent.emit(responseinfo);
          } else if (responseinfo.actionType == 10) {
            // this.controllerService.currTransections = [];
            // for (var trrow of responseinfo.trdetail) {
            //   this.controllerService.currTransections.push(trrow);
            // }
            this.CashLedgerRepResEvent.emit(responseinfo);
          } else if (responseinfo.actionType == 11) {
            // this.controllerService.currTransReport = [];
            // for (var trrow of responseinfo.trdetail) {
            //   this.controllerService.currTransReport.push(trrow);
            // }
            this.CashLedgerRepResEvent.emit(responseinfo);
          } else if (responseinfo.actionType == 12) {
            // this.controllerService.currTransReport = [];
            // for (var trrow of responseinfo.trdetail) {
            //   this.controllerService.currTransReport.push(trrow);  
            // }
            this.CashLedgerDetailRepResEvent.emit(responseinfo);
          } else {
            this.FaildedCashMasterEvent.emit();
          }
          break;
        case 109:
        case 109.1:
          if (responseinfo.actionType == 10) {
            this.LedgerRepResEvent.emit(responseinfo);
          } else if (responseinfo.actionType == 11) {
            this.LedgerRepResEvent.emit(responseinfo);
          } else if (responseinfo.actionType == 12) {
            this.LedgerRepResEvent.emit(responseinfo);
          } else if (responseinfo.actionType == 13) {
            this.LedgerRepResEvent.emit(responseinfo);
          }
          break;
        case 110:
          if (responseinfo.actionType == 10) {
            this.ResultRepResEvent.emit(responseinfo);
          } else if (responseinfo.actionType == 1) {
            this.ResultRepResEvent.emit(responseinfo);
          } else if (responseinfo.actionType == 2) {
            this.ResultRepResEvent.emit(responseinfo);
          } else if (responseinfo.actionType == 11) {
            this.ResultRepResEvent.emit(responseinfo);
          } else if (responseinfo.actionType == 12) {
            this.ResultRepResEvent.emit(responseinfo);
          } else if (responseinfo.actionType == 12.1) {
            this.ResultRepResEvent.emit(responseinfo);
          }
          break;
        case 400:
          if (responseinfo.actionType == 1) {
            this.SuccessDealerOrderEntryEvent.emit(responseinfo);
          } else if (responseinfo.actionType == 2) {
            this.UpdatedDealerOrderEntryEvent.emit();
          } else if (responseinfo.actionType == 3) {
            this.DeletedDealerOrderEntryEvent.emit();
          } else if (responseinfo.actionType == 10 || responseinfo.actionType == 12) {
            this.ReportResponseDealerOrderEntryEvent.emit(responseinfo);
          } else if (responseinfo.actionType == 13) {
            this.ReportResponseDealerOrderStatusEvent.emit(responseinfo);
          } else if (responseinfo.actionType == 11) {
            this.ReportResponseDealerOrderUpdateEntryEvent.emit(responseinfo);
          } else if (responseinfo.actionType == 101) {
            this.FaildedDealerOrderEntryEvent.emit();
          }
          break;
        default:
          console.log('hey hey something is wrong... in response');
      }
    }
    // } 
  }

  handleBroadCastedResponse(data: any) {
    // if(data.hasOwnProperty('status') || data.hasOwnProperty('duplicateValue')){
    //   if(data['status'] === 0){
    //     this.FaildedEvent.emit();
    //   }else if(data['duplicateValue'] === 101){
    //     this.DuplicateEvent.emit();
    //   }
    // }else{
    var responseinfo: any;
    responseinfo = data;
    // const myArray = [];
    // for(let key in data){
    //   if(key === 'resInfo'){
    //     myArray.push(data[key][0]);
    //   }
    // }
    // if(myArray.length>0 && myArray[0] != undefined){
    //   responseinfo = myArray[0];
    // }else{
    //   responseinfo = data['resInfo'];
    // }  
    if (responseinfo.actionType == 101) {
      this.FaildedEvent.emit();
      this.controllerService.showDialogFailedInfo(this.controllerService.ErrorCodeWithMessages.filter(x => x.id == data.actionType)[0].str1);
    } else {
      switch (responseinfo.frmid) {
        case 1:
          if (responseinfo.actionType == 1) {
            this.controllerService.userList.push(responseinfo);
          } else if (responseinfo.actionType == 2) {
            this.controllerService.userList.push(responseinfo);
          } else if (responseinfo.actionType == 3) {
            this.controllerService.findAndRemove(this.controllerService.activeUserList, 'id', responseinfo.id);
          }
          break;

        case 10:
          if (responseinfo.actionType == 1) {
            this.controllerService.colors.push(responseinfo);
          } else if (responseinfo.actionType == 2) {
            this.controllerService.findAndReplace(this.controllerService.colors, 'id', responseinfo.id,responseinfo);
          } else if (responseinfo.actionType == 3) {
            this.controllerService.findAndRemove(this.controllerService.colors, 'id', responseinfo.id);
          }
          break;

        case 11:
          if (responseinfo.actionType == 1) {
            this.controllerService.sizes.push(responseinfo);
          } else if (responseinfo.actionType == 2) {
            this.controllerService.findAndReplace(this.controllerService.sizes, 'id', responseinfo.id,responseinfo);
          } else if (responseinfo.actionType == 3) {
            this.controllerService.findAndRemove(this.controllerService.sizes, 'id', responseinfo.id);
          }
          break;

        case 12:
          if (responseinfo.actionType == 1) {
            this.controllerService.brands.push(responseinfo);
          } else if (responseinfo.actionType == 2) {
            this.controllerService.findAndReplace(this.controllerService.brands, 'id', responseinfo.id,responseinfo);
          } else if (responseinfo.actionType == 3) {
            this.controllerService.findAndRemove(this.controllerService.brands, 'id', responseinfo.id);
          }
          break;

        case 13:
          if (responseinfo.actionType == 1) {
            this.controllerService.units.push(responseinfo);
          } else if (responseinfo.actionType == 2) {
            this.controllerService.findAndReplace(this.controllerService.units, 'id', responseinfo.id,responseinfo);
          } else if (responseinfo.actionType == 3) {
            this.controllerService.findAndRemove(this.controllerService.units, 'id', responseinfo.id);
          }
          break;

        case 14:
          if (responseinfo.actionType == 1) {
            this.controllerService.classes.push(responseinfo);
          } else if (responseinfo.actionType == 2) {
            this.controllerService.findAndReplace(this.controllerService.classes, 'id', responseinfo.id,responseinfo);

            if (responseinfo.arr >= 0) {
              for (let key in responseinfo.arr) {
                this.controllerService.findAndRemove(this.controllerService.classeWiseFees, 'id', key);
              }
            }
          } else if (responseinfo.actionType == 3) {
            this.controllerService.findAndRemove(this.controllerService.classes, 'id', responseinfo.id);
          }
          break;

        case 15:
          if (responseinfo.actionType == 1) {
            this.controllerService.sections.push(responseinfo);
          } else if (responseinfo.actionType == 2) {
            this.controllerService.findAndReplace(this.controllerService.sections, 'id', responseinfo.id,responseinfo);
          } else if (responseinfo.actionType == 3) {
            this.controllerService.findAndRemove(this.controllerService.sections, 'id', responseinfo.id);
          }
          break;

        case 16:
          if (responseinfo.actionType == 1) {
            this.controllerService.subjects.push(responseinfo);
          } else if (responseinfo.actionType == 2) {
            this.controllerService.findAndReplace(this.controllerService.subjects, 'id', responseinfo.id,responseinfo);
          } else if (responseinfo.actionType == 3) {
            this.controllerService.findAndRemove(this.controllerService.subjects, 'id', responseinfo.id);
          }
          break;

        case 17:
          if (responseinfo.actionType == 1) {
            this.controllerService.feecate.push(responseinfo);
          } else if (responseinfo.actionType == 2) {
            this.controllerService.findAndReplace(this.controllerService.feecate, 'id', responseinfo.id,responseinfo);
          } else if (responseinfo.actionType == 3) {
            this.controllerService.findAndRemove(this.controllerService.feecate, 'id', responseinfo.id);
          }
          break;

        case 18:
          if (responseinfo.actionType == 1) {
            this.controllerService.accgroups.push(responseinfo);
          } else if (responseinfo.actionType == 2) {
            this.controllerService.findAndReplace(this.controllerService.accgroups, 'id', responseinfo.id,responseinfo);
          } else if (responseinfo.actionType == 3) {
            this.controllerService.findAndRemove(this.controllerService.accgroups, 'id', responseinfo.id);
          }
          break;

        case 19:
          if (responseinfo.actionType == 1) {
            this.controllerService.accsubgroups.push(responseinfo);
          } else if (responseinfo.actionType == 2) {
            this.controllerService.findAndReplace(this.controllerService.accsubgroups, 'id', responseinfo.id,responseinfo);
          } else if (responseinfo.actionType == 3) {
            this.controllerService.findAndRemove(this.controllerService.accsubgroups, 'id', responseinfo.id);
          }
          break;

        case 20:
          if (responseinfo.actionType == 1) {
            this.controllerService.doctype.push(responseinfo);
          } else if (responseinfo.actionType == 2) {
            this.controllerService.findAndReplace(this.controllerService.doctype, 'id', responseinfo.id,responseinfo);
          } else if (responseinfo.actionType == 3) {
            this.controllerService.findAndRemove(this.controllerService.doctype, 'id', responseinfo.id);
          }
          break;

        case 21:
          if (responseinfo.actionType == 1) {
            this.controllerService.items.push(responseinfo);
          } else if (responseinfo.actionType == 2) {
            this.controllerService.findAndReplace(this.controllerService.items, 'id', responseinfo.id,responseinfo);
          } else if (responseinfo.actionType == 3) {
            this.controllerService.findAndRemove(this.controllerService.items, 'id', responseinfo.id);
          }
          break;
        case 22:
          if (responseinfo.actionType == 1) {
            this.controllerService.accounts.push(responseinfo);
          } else if (responseinfo.actionType == 2) {
            this.controllerService.findAndReplace(this.controllerService.accounts, 'id', responseinfo.id,responseinfo);
          } else if (responseinfo.actionType == 3) {
            this.controllerService.findAndRemove(this.controllerService.accounts, 'id', responseinfo.id);
          }
          break;

        case 23:
          if (responseinfo.actionType == 1) {
            this.controllerService.accgroups.push(responseinfo);
          } else if (responseinfo.actionType == 2) {
            this.controllerService.findAndReplace(this.controllerService.accgroups, 'id', responseinfo.id,responseinfo);
          } else if (responseinfo.actionType == 3) {
            this.controllerService.findAndRemove(this.controllerService.accgroups, 'id', responseinfo.id);
          }
          break;
        case 24:
          if (responseinfo.actionType == 1) {
            this.controllerService.accsubgroups.push(responseinfo);
          } else if (responseinfo.actionType == 2) {
            this.controllerService.findAndReplace(this.controllerService.accsubgroups, 'id', responseinfo.id,responseinfo);
          } else if (responseinfo.actionType == 3) {
            this.controllerService.findAndRemove(this.controllerService.accsubgroups, 'id', responseinfo.id);
          }
          break;
        case 25:
          if (responseinfo.actionType == 1) {
            this.controllerService.classsubmast.push(responseinfo);
          } else if (responseinfo.actionType == 2) {
            this.controllerService.findAndReplace(this.controllerService.classsubmast, 'id', responseinfo.id,responseinfo);
          } else if (responseinfo.actionType == 3) {
            this.controllerService.findAndRemove(this.controllerService.classsubmast, 'id', responseinfo.id);
          }
          break;
        case 26:
          if (responseinfo.actionType == 1) {
            this.controllerService.classteachermast.push(responseinfo);
          } else if (responseinfo.actionType == 2) {
            this.controllerService.findAndReplace(this.controllerService.classteachermast, 'id', responseinfo.id,responseinfo);
          } else if (responseinfo.actionType == 3) {
            this.controllerService.findAndRemove(this.controllerService.classteachermast, 'id', responseinfo.id);
          }
          break;
        case 27:
          if (responseinfo.actionType == 1) {
            this.controllerService.teachers.push(responseinfo);
          } else if (responseinfo.actionType == 2) {
            this.controllerService.findAndReplace(this.controllerService.teachers, 'id', responseinfo.id,responseinfo);
          } else if (responseinfo.actionType == 3) {
            this.controllerService.findAndRemove(this.controllerService.teachers, 'id', responseinfo.id);
          }
          break;
        case 28:
          if (responseinfo.actionType == 1) {
            this.controllerService.categorys.push(responseinfo);
          } else if (responseinfo.actionType == 2) {
            this.controllerService.findAndReplace(this.controllerService.categorys, 'id', responseinfo.id,responseinfo);
          } else if (responseinfo.actionType == 3) {
            this.controllerService.findAndRemove(this.controllerService.categorys, 'id', responseinfo.id);
          }
          break;
        case 29:
          if (responseinfo.actionType == 1) {
            this.controllerService.religions.push(responseinfo);
          } else if (responseinfo.actionType == 2) {
            this.controllerService.findAndReplace(this.controllerService.religions, 'id', responseinfo.id,responseinfo);
          } else if (responseinfo.actionType == 3) {
            this.controllerService.findAndRemove(this.controllerService.religions, 'id', responseinfo.id);
          }
          break;
        case 30:
          if (responseinfo.actionType == 1) {
            this.controllerService.languages.push(responseinfo);
          } else if (responseinfo.actionType == 2) {
            this.controllerService.findAndReplace(this.controllerService.languages, 'id', responseinfo.id,responseinfo);
          } else if (responseinfo.actionType == 3) {
            this.controllerService.findAndRemove(this.controllerService.languages, 'id', responseinfo.id);
          }
          break;
        case 104:
          // if (responseinfo.actionType == 1) {
          //   this.controllerService.gateentrylist.push(new gateentryinfo(responseinfo.srno, responseinfo.name, responseinfo.address, responseinfo.tomeet,
          //     responseinfo.purpose, responseinfo.mobile, responseinfo.type, responseinfo.stdid, responseinfo.remarks, responseinfo.frmid, responseinfo.compid, responseinfo.sessid,
          //     0, responseinfo.userid, responseinfo.ctime));
          //   this.SuccessGateEntryBroadcastEvent.emit(responseinfo);
          //   // } else if (responseinfo.actionType == 2) {
          //   //   this.UpdatedGateEntryEvent.emit();
          // }
          break;
        case 101:
          if (responseinfo.actionType == 1) {
            responseinfo.class = this.controllerService.getclassname(responseinfo.stdclass);
            responseinfo.section = this.controllerService.getsectionname(responseinfo.stdsec);
            responseinfo.category = this.controllerService.getcategoryname(responseinfo.stdcat);
            responseinfo.religion = this.controllerService.getreligionname(responseinfo.stdrelgn);
            responseinfo.house = this.controllerService.gethousename(responseinfo.stdhouse);
            responseinfo.gender = responseinfo.stdgender == 1 ? 'Male' : 'Female';

            // this.controllerService.studentslist.push(responseinfo);
            if (responseinfo.std_docs != null && responseinfo.std_docs.length > 0) {
              this.controllerService.studentdocs.push(responseinfo.std);
            }
          } else if (responseinfo.actionType == 2) {

            responseinfo.class = this.controllerService.getclassname(responseinfo.stdclass);
            responseinfo.section = this.controllerService.getsectionname(responseinfo.stdsec);
            responseinfo.category = this.controllerService.getcategoryname(responseinfo.stdcat);
            responseinfo.religion = this.controllerService.getreligionname(responseinfo.stdrelgn);
            responseinfo.house = this.controllerService.gethousename(responseinfo.stdhouse);
            responseinfo.gender = responseinfo.stdgender == 1 ? 'Male' : 'Female';

            // this.controllerService.findAndReplace(this.controllerService.studentslist, 'id', responseinfo.id,responseinfo);
            if (responseinfo.std_docs != null && responseinfo.std_docs.length > 0) {
              for (let entry of responseinfo.std_docs) {
                if (entry.del != null && entry.del == true) {
                  this.controllerService.findAndRemove(this.controllerService.studentdocs, 'recid', entry.recid);
                } else {
                  entry.id = entry.recid;
                  if (this.controllerService.studentdocs.find(x => x.recid == entry.recid) != null) {
                    this.controllerService.findAndReplace(this.controllerService.studentdocs, 'recid', entry.id,entry);
                  } else {
                    this.controllerService.studentdocs.push(entry);
                  }
                }
              }
            }
          }
          break;
        case 102:
          // if (responseinfo.actionType == 1 || responseinfo.actionType == 2) {
          //   var currstd = this.controllerService.studentslist.find(x => x.id == responseinfo.stdid);
          //   responseinfo.stdname = currstd.stdname;
          //   responseinfo.stdadmno = currstd.stdadmno;
          //   responseinfo.stdfathnm = currstd.stdfathrnm;
          //   responseinfo.stdclass = this.controllerService.getclassname(currstd.stdclass);
          //   responseinfo.stdsection = this.controllerService.getsectionname(currstd.stdsec);
          //   responseinfo.paymodename = this.controllerService.getpaymentmodename(responseinfo.paymode);
          //   responseinfo.username = this.controllerService.getUserName(responseinfo.userid);

          //   if (responseinfo.actionType == 2) {
          //     this.controllerService.findAndReplace(this.controllerService.feedaybooklist, 'id', responseinfo.id,responseinfo);
          //   } else {
          //     this.controllerService.feedaybooklist.push(responseinfo);
          //   }
          //   this.SuccessFeeEntryBroadcastEvent.emit(responseinfo);
          // }
          break;

        default:
          console.log('hey hey something is wrong... in response');
      }
    }
    // } 
  }
}